exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ReportsPage-bfd6d1c4{background:#f7f7f7;min-height:100vh}\n", ""]);

// Exports
exports.locals = {
	"ReportsPage": "ReportsPage-bfd6d1c4"
};